function cov_27ficyzang() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Video.tsx";
  var hash = "d6c436fb7e34b520759c853296bce8b2908beca5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Video.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d6c436fb7e34b520759c853296bce8b2908beca5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_27ficyzang = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_27ficyzang();
var Icon = (cov_27ficyzang().s[0]++, {
  name: 'video',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.1126 13.6338L20.5 16.0558V8.58415L14.1126 11.0062V6.5H3.5V17.5H14.1126V13.6338ZM20.1198 6.05462C20.14 6.04799 20.1601 6.04133 20.1803 6.03467C21.5435 5.5851 23 5.10473 23 7.67391V16.9661C23 18.9333 22.5 19.4667 20.1198 18.5854L16.6126 17.2555V18.08C16.6126 18.7198 16.3073 19.2865 15.8378 19.6354C15.5291 19.8648 15.1495 20 14.7391 20H2.87351C1.8388 20 1 19.1404 1 18.08V5.92C1 4.85961 1.8388 4 2.87351 4H14.7391C15.3809 4 15.9474 4.33076 16.285 4.83503C16.4917 5.1437 16.6126 5.51737 16.6126 5.92V7.3845L20.1198 6.05462ZM20.472 7.28017L20.4716 7.27848L20.472 7.28017Z\" fill=\"currentColor\"/>"
});
export default Icon;